import { ComponentType, PropsWithChildren } from 'react';
import { Text as BaseText, TextProps } from 'react-native';
import { TextNestingContext } from 'shared/components/text-nesting-context';

const BaseTextWithWebProps = BaseText as ComponentType<
  PropsWithChildren<TextProps & { className?: string }>
>;

const Text = function ({
  className = '',
  skipDefaults,
  ...props
}: PropsWithChildren<TextProps & { className?: string; skipDefaults?: boolean }>) {
  return (
    <BaseTextWithWebProps
      {...props}
      className={`${className} ${skipDefaults ? '' : 'text-defaults'}`}
      allowFontScaling={false}
    >
      <TextNestingContext.Provider value={true}>{props.children}</TextNestingContext.Provider>
    </BaseTextWithWebProps>
  );
};

export { Text };
